export default {
  install(Vue: any, options: any) {
    Vue.$streetview = Vue.prototype.$streetview = {
      googleApiKey: options.googleMapsApiKey,
      googleUrl: 'https://maps.googleapis.com/maps/api/streetview',

      createRequestObject(url: string, callback: any = null) {
        var xhr = new XMLHttpRequest()

        /* Register callback functions */
        xhr.onreadystatechange = function() {
          if (xhr.readyState === 4 && xhr.status === 200) {
            if (callback) {
              callback(xhr.response)
            }
          }
        }

        xhr.responseType = 'arraybuffer'
        xhr.open('GET', url)
        return xhr
      },

      getDefaultUrl() {
        let url = this.googleUrl
        url += '?key=' + encodeURIComponent(this.googleApiKey)
        return url
      },

      send(dataObj: Object, callback = null) {
        this.getResult(dataObj, callback)
      },

      getResult(data: any, callback = null) {
        let url = this.getDefaultUrl()
        /* Add query parameters */
        url += '&size=550x400'
        url += `&location=${data.location}`
        url += `&heading=${data.heading}`
        url += `&pitch=${data.pitch}`
        const xhr = this.createRequestObject(url, callback)
        xhr.send()
      },
    }
  },
}
